import React, { useState, useCallback, forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import RadioButton from '../radio-button';
import RichTextBase from '../../rich-text/base';
import { RichTextPropTypes } from '../../../prop-types';
import { Wrapper } from './styles';

const RadioButtonGroup = forwardRef(
  (
    {
      error,
      options,
      label,
      description,
      name,
      value,
      defaultValue,
      id,
      inline,
      onChange,
      boldWhenChecked,
      legend,
      ...rest
    },
    ref
  ) => {
    const [state, setState] = useState(defaultValue);

    useEffect(() => {
      if (value) setState(value);
    }, [value]);

    const changeHandler = useCallback(
      (event) => {
        setState(event.currentTarget.value);

        if (onChange) {
          onChange(event);
        }
      },
      [onChange]
    );

    const { labelSize, ...filteredRest } = rest;

    return (
      <Wrapper $inline={inline}>
        {legend && legend}
        {description && <RichTextBase richText={description} />}

        {options.map((option, index) => (
          <React.Fragment key={`${id}-${index}`}>
            <RadioButton
              name={name}
              ref={index === 0 ? ref : null}
              id={`${id}-${index}`}
              value={option.value}
              label={option.label}
              onClick={changeHandler}
              checked={state === option.value}
              defaultChecked={state === option.value}
              disabled={option.disabled}
              boldWhenChecked={boldWhenChecked}
              {...filteredRest}
            />
            {!inline && state === option.value && option.content
              ? option.content
              : null}
          </React.Fragment>
        ))}
      </Wrapper>
    );
  }
);

RadioButtonGroup.displayName = 'RadioButtonGroup';

RadioButtonGroup.propTypes = {
  error: PropTypes.bool,
  label: PropTypes.string,
  description: RichTextPropTypes,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      content: PropTypes.element,
    })
  ).isRequired,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  inline: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  boldWhenChecked: PropTypes.bool,
  legend: PropTypes.node,
};

export default RadioButtonGroup;
